module.exports = __webpack_public_path__ + "media/components/SideNav/logo-4df7aa7defe8ee12152ad99534141b0d.svg";